import React, { useState } from 'react';
import { FlexBox, InlineItemWithMargin } from '../Components';
import { getTranslateByScope } from '../i18n';
import AppContext from '../AppContext';
import { genres } from '../constants';
import { TopMenuModal } from './TopMenuModal';
import { Genre } from './Genre';

export const translate = getTranslateByScope('app.genres');

export const GenrePicker = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <AppContext.Consumer>
      {({ actions }) => (
          <>
            <TopMenuModal isOpen={isOpen} setIsOpen={setIsOpen} />
            <div onMouseEnter={() => setIsOpen(true)}>
              <FlexBox>
                <Genre
                  setIsOpen={setIsOpen}
                  value={genres.men}
                  actions={actions}
                />
                <InlineItemWithMargin>
                  <Genre
                    setIsOpen={setIsOpen}
                    value={genres.woman}
                    actions={actions}
                  />
                </InlineItemWithMargin>
              </FlexBox>
            </div>
          </>
      )}
    </AppContext.Consumer>
  );
};

export default GenrePicker;
